import { FormControl } from "@mui/material";
import { type FC } from "react";
import { Controller, FormProvider, useFormContext } from "react-hook-form";
import type { MomentFormMoment } from "../moment/types/moment-form-moment";
import { SlackAliasSelector } from "../slack/components/slack-alias-selector";
import { useToTarget } from "../to/use-to-target";

export const MomentSlackAliasSelector: FC = () => {
  const methods = useFormContext<MomentFormMoment>();
  const { control, setValue } = methods;

  const { toTarget } = useToTarget();

  return (
    <FormProvider {...methods}>
      <FormControl variant="standard" sx={{ minWidth: 120 }} fullWidth>
        <Controller
          name="from"
          control={control}
          render={({ field }) => {
            return (
              <SlackAliasSelector
                {...field}
                toTarget={toTarget}
                reset={() => setValue("from", null)}
              />
            );
          }}
        />
      </FormControl>
    </FormProvider>
  );
};
